<template>
    <wrapper-features-templates-one-column
    :nonAuthenticatedFeature="nonAuthenticatedRoute"
	@backOrCloseClicked="emit('backOrCloseClicked')">
		<empty-state-generic
		illustration="emptyState/available-soon"
		:title="t('underDevelopment.title')" :description="t('underDevelopment.description')"/>
	</wrapper-features-templates-one-column>
</template>

<script setup>
import WrapperFeaturesTemplatesOneColumn from '@/components/wrappers/featuresTemplates/OneColumn'
import EmptyStateGeneric from '@/components/generic/emptyStates/Generic'

/* Vue & Helpers */
import { computed } from 'vue'
import { nonAuthenticatedRoutes } from '@/router/helpers/validations'
import { useRoute } from 'vue-router'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['backOrCloseClicked', 'updateLoginLoader'])

emit('updateLoginLoader', false)

const currentRoute = useRoute()

/* Controls if current route is non authenticated */
const nonAuthenticatedRoute = computed(() => {
    return nonAuthenticatedRoutes().has(currentRoute.path)
})

</script>

<style lang="scss" scoped>
</style>
